/**
 * Billing UI constants
 * Thresholds and conversions specific to the billing UI
 */

// Usage thresholds for progress bar colors
export const USAGE_WARNING_THRESHOLD = 75;
export const USAGE_CRITICAL_THRESHOLD = 90;

// Time conversion
export const MS_PER_SECOND = 1000;
